import React, { PureComponent, PropTypes } from 'react';
import LiLink from './LiLink';

export default class PillNav extends PureComponent {
  static propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.node.isRequired,
      to: PropTypes.string.isRequired
    })).isRequired
  };

  static defaultProps = {};

  render() {
    const { options } = this.props;

    return (
      <ul className="nav nav-pills">
        {
          options.map(
            ({ label, to, ...rest }, ix) => (<LiLink key={ix} to={to} {...rest}>{label}</LiLink>)
          )
        }
      </ul>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/components/PillNav.jsx